// wiki for tokenType https://wiki.linecorp.com/pages/viewpage.action?pageId=3075586070

export const friendsMap = {
  CitizenCat: {
    tokenType: '10000006',
    level: 1,
    evolvable: true,
  },
  CitizenDog: {
    tokenType: '1000000b',
    level: 1,
    evolvable: true,
  },
  CitizenRoboCat: {
    tokenType: '1000000c',
    level: 1,
    evolvable: false,
  },
  CitizenGoose: {
    tokenType: '10000017',
    level: 1,
    evolvable: true,
  },
  CitizenChameleon: {
    tokenType: '10000017',
    level: 1,
    evolvable: true,
  },
  CitizenRoboRex: {
    tokenType: '10000017',
    level: 1,
    evolvable: false,
  },
};
